import crowChatConfig from './config';
import crowChatApi from './api';

/**
 * CrowChat Agent Module
 * Exports configuration and API for the CrowChat demo agent
 */

export { crowChatConfig, crowChatApi };

const crowChatAgent = {
  config: crowChatConfig,
  api: crowChatApi,
};

export default crowChatAgent;
